<section>
  <!-- Table -->
  <div class="row mt-2 px-0 g-0">
    <table class="table table-borderless">
      <thead class="text-center">
        <tr>
          @for (column of columns; track column) {
          <th>{{ column.name | translate }}</th>
          }
        </tr>
      </thead>
      @if (tableData.length) {
      <tbody>
        @for (group of tableData; track group) { @for (change of group.changes;
        track change; let i = $index, let last = $last) {
        <tr
          [ngClass]="group.changes.length > 1 ? 'rowspan-wrapper' : ''"
          [class.last-rowspan]="i === group.changes.length - 1">
          <!-- Grouped Date and User Name -->
          <td
            [attr.rowspan]="group.changes.length"
            class="grouped"
            pTooltip="{{ group.dateTime | localizedDate: 'yyyy-MM-dd hh:mm a' }}"
            tooltipPosition="bottom">
            <span
              >{{ group.dateTime ? (group.dateTime + 'Z' | localizedDate :
              (currentLanguage === 'ar' ? "yyyy/MM/dd 'في' h:mm a" : "dd/MM/yyyy
              'at' h:mm a")) : '-' }}</span
            >
          </td>
          <td
            [attr.rowspan]="group.changes.length"
            class="grouped"
            pTooltip="{{group.userName}}"
            tooltipPosition="bottom">
            @if (i === 0) { {{ group.userName}} }
          </td>
          <td [attr.rowspan]="group.changes.length" class="grouped">
            <span>{{ change.action ? (change.action ) : '-' }}</span>
          </td>

          <!--  rendered per change -->

          <td
            pTooltip="{{change.field}}"
            tooltipPosition="bottom"
            [ngClass]="{'bottom-border': i !== group.changes.length - 1}">
            <span>{{ change.field ?( change.field): '-' }}</span>
          </td>
          <td
            pTooltip="{{change.oldValue}}"
            tooltipPosition="bottom"
            [ngClass]="{'bottom-border': i !== group.changes.length - 1}">
            <span>{{ change.oldValue ? (change.oldValue) : '-'}}</span>
          </td>
          <td
            pTooltip="{{change.newValue}}"
            tooltipPosition="bottom"
            [ngClass]="{'bottom-border': i !== group.changes.length - 1}">
            <span>{{ change.newValue ? (change.newValue) :'-'}}</span>
          </td>
        </tr>
        } }
      </tbody>
      } @if (!tableData?.length) {
      <app-no-result-found></app-no-result-found>
      }
    </table>
  </div>
  <!-- pagination -->
  <!-- pagination -->
  @if(tableData?.items?.length){
  <app-pagination
    [tableData]="tableData"
    [config]="config"
    [maxSize]="maxSize"
    [currentLanguage]="currentLanguage"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="changePageCount($event)">
  </app-pagination>
  }
</section>
